import React from 'react';
import { Link } from 'react-router-dom';
import HeaderWithoutLang from '../HeaderWithoutLang';
import Footer from '../Footer';
import '../../assets/css/main.css';

const businesses = [
  {
    id: 1,
    name: 'Greenway Mobility',
    verified: true,
    rating: 5,
    tagline: 'Naye Daur Ka Mazboot Saathi',
    description: 'With years of industry expertise and a strong commitment to quality, we are recognized as one of India\'s most reliable commercial vehicle solutions providers. Our extensive range includes everything from light-duty pickups to heavy-duty.',
    image: '/images/business1.png',
  },
];

// Function to convert business name to URL-friendly slug
const createSlug = (name) => {
  return name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
};

const BusinessListingPage = () => {
  return (
    <>
      <HeaderWithoutLang />
      <section className="business-listing-hero">
        <div className="business-listing-hero-content">
          <h1>Check Out Businesses Building<br />From & For Bharat!</h1>
          <p>Connect with verified businesses<br />across India</p>
        </div>
      </section>
      <section className="featured-businesses-section">
        <h2 className="featured-title">Featured Businesses</h2>
        <p className="featured-desc">Explore top businesses handpicked for their exceptional service, customer trust, and industry reputation.</p>
        <div className="business-cards-list">
          {businesses.map((biz, idx) => (
            <div className="business-card" key={biz.id}>
              <div className="business-card-img">
                <img src={biz.image} alt={biz.name} />
              </div>
              <div className="business-card-content">
                <div className="business-card-header">
                  <span className="business-card-title">{biz.name}</span>
                  {biz.verified && <span className="business-card-verified">Verified <img src="/images/verified.svg" alt="Verified" /></span>}
                </div>
                <div className="business-card-rating">
                  {Array.from({ length: biz.rating }).map((_, i) => (
                    <span key={i} className="star filled">★</span>
                  ))}
                  <span className="rating-value">{biz.rating}</span>
                </div>
                <div className="business-card-tagline">{biz.tagline}</div>
                <div className="business-card-desc">{biz.description}</div>
                <Link to={`/business-details/${createSlug(biz.name)}`} className="business-card-link">
                  View Details <span className="arrow">→</span>
                </Link>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="view-all-btn-container">
          <button className="view-all-btn">View All</button>
        </div> */}
      </section>
      <Footer />
    </>
  );
};

export default BusinessListingPage;
